module.exports = __webpack_public_path__ + "media/images/icones-herospark-h-bb194a1afaaa2dd6f6ca9df43fede3bc.png";